export const MIN_MESSAGE_LENGTH: number = 2;
export const ENTER_KEY: string = "Enter";
export const LINE_BREAK: string = "\n";
